import React from 'react';
import { EA } from 'react-easy-alert';

EA.initialize(
  {
    appId: '68acc5b90362652fbd21523f',
    vapidKey: 'BCiPtbKevqttHLSbVVAHIoBiAqr5gfc9j3RMuewRw_8axSvDszV9ir6gLBGDK3tMo5n4Tb2PjzeYj19x8cyIhfM',
  },
);

EA.Notifications.addEventListener('click', ({ data }) => {
  if (data && data.launch_url) {
    console.log(data.launch_url);
  }
});

EA.Notifications.addEventListener('foregroundWillDisplay', (data) => {
  // new Notification(notificationTitle, notificationOptions);
});

function App() {

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>

    </div>
  );
}

export default App;